import Text from 'components/Text/Text';
import FormInput from 'components/Input/FormInput';
import MasterPhoneField from './components/MasterPhoneField';
import Mcc from './components/Mcc/Mcc';
import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { Form } from 'antd';
import { BtnBlock } from './components/BtnBlock';
import { ClientTypeSelect } from './components/ClientTypeSelect';
import EmailField from './components/EmailField';
import CodeField from './components/CodeField';
import LoyaltyField from './components/LoyaltyField';
import AdditionalApplicationsMultipleSelect from './components/AdditionalApplicationsMultipleSelect';
import VivaWallet from './components/VivaWallet/VivaWallet';
import { Supplier } from './components/Supplier/Supplier';
import PriceTypeField from './components/PriceTypeField';
import IsUsedCustomerPriceTypeCheckbox from './components/IsUsedCustomerPriceTypeCheckbox';
import { IsApplicableForVat } from './components/IsApplicableForVat';
import NameField from './components/NameField';
import ShortNameField from './components/ShortNameField';
import IsUseCustomerTipsCheckBox from './components/IsUseCustomerTipsCheckBox';
import { TipsBlock } from 'components/TipsBlock/TipsBlock';
import { Charity } from './components/Charity/Charity';
import UseKmTariffCheckBox from './components/UseKmTariffCheckBox';
import TipsCommissionPercentField from './components/TipsCommissionPercentField';
import { TipsCommissionMaxValueField } from './components/TipsCommissionMaxValueField';
import ShowLoyaltyProgramButtonsCheckBox from './components/ShowLoyaltyProgramButtonsCheckBox';
import DownloadAppAndroidUrlField from './components/DownloadAppAndroidUrlField';
import DownloadAppIosUrlField from './components/DownloadAppIosUrlField';
import DefaultLanguageSelect from './components/DefaultLanguageSelect';
import LanguagesMultipleSelect from './components/LanguagesMultipleSelect';
import CustomerSelect from './components/CustomerSelect';
import CountrySelect from './components/CountrySelect';
import CitySelect from './components/CitySelect';
import AddressField from './components/AddressField';
import CurrencySelect from './components/CurrencySelect';
import RestrictionQrValueField from './components/RestrictionQrValueField';
import UsePosPhotosCheckBox from './components/UsePosPhotosCheckBox';
import EnableStopListJobCheckBox from './components/EnableStopListJobCheckBox';
import { UseCustomerStopListSyncIntervalCheckBox } from './components/UseCustomerStopListSyncIntervalCheckBox';
import { StopListSyncIntervalField } from './components/StopListSyncIntervalField';
import UpdateOfTheLauncherCheckBox from './components/UpdateOfTheLauncherCheckBox';
import UseCustomerMenuVersionCheckBox from './components/UseCustomerMenuVersionCheckBox';
import UseCustomerContentVersionCheckBox from './components/UseCustomerContentVersionCheckBox';
import MenuVersionField from './components/MenuVersionField';
import ContentVersionField from './components/ContentVersionField';
import UseRestaurantMenuVersionCheckBox from './components/UseRestaurantMenuVersionCheckBox';
import UseRestaurantContentVersionCheckBox from './components/UseRestaurantContentVersionCheckBox';
import CardAcceptorIdField from './components/CardAcceptorIdField';
import CardAcceptorNameField from './components/CardAcceptorNameField';
import TerminalIdField from './components/TerminalIdField';
import VatField from './components/VatField';
import TimeBlockChildAccessField from './components/TimeBlockChildAccessField';
import PosSystemSelect from './components/PosSystemSelect';
import LauncherSettingsUploader from './components/LauncherSettingsUploader';
import { Bpa } from './components/Bpa';
import UseTLSCertificate from './components/UseTLSCertificate';
import SendDeviceUnavailabilityAlerts from './components/SendDeviceUnavailabilityAlerts';
import TLSCertificateLevelSelect from './components/TLSCertificateLevelSelect';
import { TlsCertificateNameField } from './components/TlsCertificateNameField';
import TlsFileSection from './components/TlsFileSection';
import { VatIdField } from './components/VatIdField';
import { PaymentTypeIdField } from './components/PaymentTypeIdField';
import { IMccCard, CardBrands } from 'types';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import {
	EditRestaurantContext,
	IEditRestaurantContext,
} from '../../../../../../editRestaurantState/editRestaurantContext';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './InputFields.module.scss';
import ExtraPaymentTypeIds from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/components/Forms/components/EditForm/components/InputFields/components/ExtraPaymentTypes/ExtraPaymentTypes';

export const InputFields: React.FC = React.memo(() => {
	const { featureFlags } = useContext<IAppContext>(AppContext);
	const { setMainFormValidationFail, additionalValidationErrors } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		changeName,
		changeShortName,
		setIDCustomer,
		setFetchedCustomers,
		setClientType,
		setIDCountry,
		setFetchedCountries,
		setIDCity,
		setFetchedCities,
		changeAddress,
		setCurrencySymbol,
		setFetchedCurrencies,
		changeMasterPhoneNumber,
		changeEmail,
		changeCode,
		setAdditionalApplications,
		changeVivaWalletIsv,
		changeSupplier,
		toggleIsOpenPriceServiceCharge,
		changeOpenPricePercent,
		changePriceType,
		toggleIsUsedCustomerPriceType,
		changeLoyalty,
		toggleIsUsedCustomerTips,
		setTips0,
		setTips1,
		setTips2,
		setTips3,
		setDefaultTips,
		setTipsCommissionPercent,
		setTipsCommissionMaxValue,
		toggleIsCharityEnabled,
		changeCharityName,
		setCharityLogoFile,
		setCharityAmount0,
		setCharityAmount1,
		setCharityAmount2,
		setCharityAmount3,
		setDefaultCharityAmountIndex,
		toggleUseKmTariff,
		toggleShowLoyaltyProgramButtons,
		addMccCard,
		deleteMccCard,
		changeBaseMcc,
		changeMainMccCardBrand,
		changeMccCardBrand,
		changeMainMccCardMcc,
		changeMccCardMcc,
		toggleUseCustomerMcc,
		changeDownloadAppAndroidUrl,
		changeDownloadAppIosUrl,
		setIDDefaultLanguage,
		setFetchedLanguages,
		setIDsLanguages,
		changeRestrictionQrValue,
		toggleUsePosPhotos,
		toggleStopListJob,
		toggleUseCustomerStopListSyncInterval,
		changeStopListSyncIntervalMinutes,
		toggleUpdateOfTheLauncher,
		changeCardAcceptorId,
		changeCardAcceptorName,
		changeTerminalId,
		changeVat,
		changeTimeBlockChildAccess,
		setIDPosSystem,
		setFileIdForLauncherSettings,
		toggleUseMenuVersion,
		toggleUseContentVersion,
		changeRestaurantMenuVersion,
		changeRestaurantContentVersion,
		toggleUseTLSCertificate,
		setTlsCertificateLevel,
		changeTlsCertificateName,
		setTlsCertificateFile,
		changeVatId,
		changeKmVatId,
		setBpaSetId,
		toggleApplicableForVat,
		toggleSendDeviceUnavailabilityAlerts,
		changePaymentTypeId,
		addExtraPaymentType,
		changeExtraPaymentType,
		deleteExtraPaymentType,
		restaurantId,
		name,
		shortName,
		IDSelectedCustomer,
		clientType,
		IDSelectedCountry,
		IDSelectedCity,
		address,
		selectedCurrencySymbol,
		masterPhoneNumber,
		email,
		code,
		additionalApplications,
		vivaWalletIsv,
		supplier,
		isOpenPriceServiceCharge,
		openPricePercent,
		priceType,
		isUsedCustomerPriceType,
		loyalty,
		isUsedCustomerTips,
		tips0,
		tips1,
		tips2,
		tips3,
		defaultTips,
		tipsCommissionPercent,
		tipsCommissionMaxValue,
		isCharityEnabled,
		charityName,
		charityLogoPath,
		charityLogoFileId,
		charityAmount0,
		charityAmount1,
		charityAmount2,
		charityAmount3,
		defaultCharityAmountIndex,
		useKmTariff,
		isShowCustomerLoyaltyProgramButtons,
		isShowLoyaltyProgramButtons,
		baseMcc,
		mainMccCardBrand,
		mainMccCardMcc,
		mccCards,
		useCustomerMcc,
		downloadAppAndroidUrl,
		downloadAppIosUrl,
		IDDefaultLanguage,
		IDsLanguages,
		restrictionQrValue,
		usePosPhotos,
		enableStopListJob,
		useCustomerStopListSyncInterval,
		stopListSyncIntervalMinutes,
		updateOfTheLauncher,
		cardAcceptorId,
		cardAcceptorName,
		terminalId,
		vat,
		timeBlockChildAccess,
		IDPosSystem,
		fileIdForLauncherSettings,
		launcherSettingFilePath,
		useMenuVersion,
		useContentVersion,
		restaurantMenuVersion,
		restaurantContentVersion,
		useTlsCertificate,
		tlsCertificateLevel,
		tlsCertificateName,
		tlsCertificateFilePath,
		tlsCertificateFileId,
		tlsCertificateFileHash,
		vatId,
		kmVatId,
		isActiveBpa,
		bpaSetId,
		isApplicableForVat,
		sendDeviceUnavailabilityAlerts,
		paymentTypeId,
		extraPaymentTypes,
	} = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const superUserAccess = useRoleAccess([UserRoles.SUPER_USER]);
	const [form] = Form.useForm();
	const versionHeadingClasses = classNames(style.row, style.flex1, style.versionHeading);
	const rowWithFlex1Classes = classNames(style.row, style.flex1);
	const rowWithAlignItemsCenterClasses = classNames(style.row, style.alignItemsCenter);

	useEffect(() => {
		form.setFieldsValue({
			name,
			shortName,
			IDSelectedCustomer,
			clientType,
			IDSelectedCountry,
			IDSelectedCity,
			address,
			selectedCurrencySymbol,
			masterPhoneNumber,
			email,
			code,
			additionalApplications,
			sourceId: vivaWalletIsv.sourceId,
			isvSourceId: vivaWalletIsv.isvSourceId,
			isvPercen: vivaWalletIsv.isvPercent,
			isvFixedFeeAmount: vivaWalletIsv.isvFixedFeeAmount,
			isvFixedFeeThreshold: vivaWalletIsv.isvFixedFeeThreshold,
			pinCode: vivaWalletIsv.pinCode,
			franchiseFeeSupported: vivaWalletIsv.franchiseFeeSupported,
			franchisePercent: vivaWalletIsv.franchisePercent,
			franchiseFixedFeeAmount: vivaWalletIsv.franchiseFixedFeeAmount,
			franchiseFixedFeeThreshold: vivaWalletIsv.franchiseFixedFeeThreshold,
			supplierTaxpayerId: supplier.taxpayerId,
			supplierPhone: supplier.phone,
			supplierName: supplier.name,
			isOpenPriceServiceCharge,
			openPricePercent,
			priceType,
			isUsedCustomerPriceType,
			loyalty,
			isUsedCustomerTips,
			tips0,
			tips1,
			tips2,
			tips3,
			defaultTips,
			tipsCommissionPercent,
			tipsCommissionMaxValue,
			charityName,
			charityAmount0,
			charityAmount1,
			charityAmount2,
			charityAmount3,
			defaultCharityAmountIndex,
			useKmTariff,
			isShowLoyaltyProgramButtons,
			baseMcc,
			mainMccCardBrand,
			mainMccCardMcc,
			useCustomerMcc,
			downloadAppAndroidUrl,
			downloadAppIosUrl,
			IDDefaultLanguage,
			IDsLanguages,
			restrictionQrValue,
			usePosPhotos,
			enableStopListJob,
			stopListSyncIntervalMinutes,
			updateOfTheLauncher,
			cardAcceptorId,
			cardAcceptorName,
			terminalId,
			vat,
			timeBlockChildAccess,
			IDPosSystem,
			fileIdForLauncherSettings,
			useMenuVersion,
			useContentVersion,
			restaurantMenuVersion,
			restaurantContentVersion,
			useTlsCertificate,
			tlsCertificateLevel,
			tlsCertificateName,
			vatId,
			kmVatId,
			bpaSetId,
			isApplicableForVat,
			sendDeviceUnavailabilityAlerts,
			paymentTypeId,
		});
		mccCards.forEach((el) => {
			form.setFieldsValue({ [`cardBrand-${el.id}`]: el.brand, [`mcc-${el.id}`]: el.mcc });
		});
		extraPaymentTypes.forEach((el) => {
			form.setFieldsValue({
				[`extraPaymentTypeId-${el.id}`]: el.paymentTypeId,
				[`extraCardBrand-${el.id}`]: el.brand,
			});
		});
	}, [
		name,
		shortName,
		IDSelectedCustomer,
		clientType,
		IDSelectedCountry,
		IDSelectedCity,
		address,
		selectedCurrencySymbol,
		masterPhoneNumber,
		email,
		code,
		additionalApplications,
		vivaWalletIsv,
		supplier,
		isOpenPriceServiceCharge,
		openPricePercent,
		priceType,
		isUsedCustomerPriceType,
		loyalty,
		isUsedCustomerTips,
		tips0,
		tips1,
		tips2,
		tips3,
		defaultTips,
		tipsCommissionPercent,
		tipsCommissionMaxValue,
		charityName,
		charityAmount0,
		charityAmount1,
		charityAmount2,
		charityAmount3,
		defaultCharityAmountIndex,
		useKmTariff,
		isShowLoyaltyProgramButtons,
		baseMcc,
		mainMccCardBrand,
		mainMccCardMcc,
		mccCards,
		useCustomerMcc,
		downloadAppAndroidUrl,
		downloadAppIosUrl,
		IDDefaultLanguage,
		IDsLanguages,
		restrictionQrValue,
		usePosPhotos,
		enableStopListJob,
		stopListSyncIntervalMinutes,
		updateOfTheLauncher,
		cardAcceptorId,
		cardAcceptorName,
		terminalId,
		vat,
		timeBlockChildAccess,
		IDPosSystem,
		fileIdForLauncherSettings,
		useMenuVersion,
		useContentVersion,
		restaurantMenuVersion,
		restaurantContentVersion,
		useTlsCertificate,
		tlsCertificateLevel,
		tlsCertificateName,
		vatId,
		kmVatId,
		bpaSetId,
		isApplicableForVat,
		sendDeviceUnavailabilityAlerts,
		paymentTypeId,
		extraPaymentTypes,
	]);

	const reservedMccCardBrands: (CardBrands | null)[] = [mainMccCardBrand, ...mccCards.map((el) => el.brand)];

	const submit = async () => {
		setMainFormValidationFail(false);

		const finalMasterPhoneNumber = masterPhoneNumber.replace(/\s/g, '');
		const finalSupplierPhone = supplier.phone ? supplier.phone.replace(/\s/g, '') : null;

		const finalMccCards = () => {
			const result: Pick<IMccCard, 'brand' | 'mcc'>[] = [];

			if (mainMccCardBrand && mainMccCardMcc) {
				result.push({ brand: mainMccCardBrand, mcc: mainMccCardMcc });
			}

			mccCards.forEach((el) => {
				if (el.brand && el.mcc) {
					result.push({ brand: el.brand, mcc: el.mcc });
				}
			});

			return result;
		};

		const finalExtraPaymentTypeIds: { [key: string]: string } = extraPaymentTypes.reduce((acc, el) => {
			if (el.brand === null || el.paymentTypeId === null) {
				return acc;
			}

			acc[String(el.brand)] = el.paymentTypeId;
			return acc;
		}, {} as { [key: string]: string });

		setDataForSubmit({
			restaurantId,
			name,
			shortName,
			address,
			customerId: IDSelectedCustomer || '',
			cityId: IDSelectedCity || '',
			countryId: IDSelectedCountry || '',
			defaultLanguageId: IDDefaultLanguage || '',
			restaurantType: clientType || 1,
			isoCurrencySymbol: selectedCurrencySymbol || '',
			masterPhoneNumber: finalMasterPhoneNumber || null,
			email,
			code: code ? code.toUpperCase() : null,
			additionalApplications,
			vivaWalletIsv: additionalApplications.includes('VivaWallet')
				? {
						sourceId: vivaWalletIsv.sourceId,
						isvSourceId: vivaWalletIsv.isvSourceId ? vivaWalletIsv.isvSourceId : null,
						isvPercent: vivaWalletIsv.isvPercent || 0,
						isvFixedFeeAmount: vivaWalletIsv.isvFixedFeeAmount || 0,
						isvFixedFeeThreshold: vivaWalletIsv.isvFixedFeeThreshold || 0,
						pinCode: vivaWalletIsv.pinCode ? vivaWalletIsv.pinCode : '',
						franchiseCommission: vivaWalletIsv.franchiseFeeSupported
							? {
									percent: vivaWalletIsv.franchisePercent,
									fixedAmount: vivaWalletIsv.franchiseFixedFeeAmount,
									fixedAmountThreshold: vivaWalletIsv.franchiseFixedFeeThreshold,
							  }
							: null,
				  }
				: null,
			supplier: supplier.taxpayerId
				? {
						...supplier,
						phone: finalSupplierPhone,
				  }
				: null,
			isOpenPriceServiceCharge,
			openPricePercent,
			priceType,
			isUsedCustomerPriceType,
			loyalty: Number(loyalty),
			posSystemId: IDPosSystem,
			isUsedCustomerTips,
			defaultTips: [
				{ value: tips0, isDefault: defaultTips === '0' },
				{ value: tips1, isDefault: defaultTips === '1' },
				{ value: tips2, isDefault: defaultTips === '2' },
				{ value: tips3, isDefault: defaultTips === '3' },
			],
			tipsCommissionPercent,
			tipsCommissionMaxValue,
			commissionTariff: useKmTariff ? 'KATEMEDIA' : 'GENERAL',
			isShowLoyaltyProgramButtons,
			merchantCategoryCode: {
				baseMcc: baseMcc || 0,
				mccCards: finalMccCards(),
			},
			useCustomerMcc,
			downloadAppAndroidUrl,
			downloadAppIosUrl,
			cardAcceptorId,
			cardAcceptorName,
			terminalId,
			terminal: Number(vat),
			timeBlock: Number(timeBlockChildAccess),
			restrictionQrValue,
			usePosPhotos,
			syncStopList: enableStopListJob,
			useCustomerStopListSyncInterval,
			stopListSyncIntervalMinutes,
			updateOfTheLauncher,
			launcherSettingFileId: fileIdForLauncherSettings || '',
			restaurantsLanguages: IDsLanguages,
			useTlsCertificate,
			tlsCertificateLevel: tlsCertificateLevel ? tlsCertificateLevel : 'None',
			tlsCertificateName,
			tlsCertificateFileId,
			tlsCertificateFileHash,
			vatId: vatId || null,
			kmVatId: kmVatId || null,
			useMenuVersion,
			useContentVersion,
			menuVersion: restaurantMenuVersion || null,
			contentVersion: restaurantContentVersion || null,
			bpaSetId,
			isApplicableForVat,
			sendDeviceUnavailabilityAlerts,
			paymentTypeId,
			extraPaymentTypes: finalExtraPaymentTypeIds,
			isCharityEnabled,
			charityName: charityName || null,
			charityLogoFileId,
			charityAmounts: [
				{ amount: charityAmount0, isDefault: defaultCharityAmountIndex === 0 },
				{ amount: charityAmount1, isDefault: defaultCharityAmountIndex === 1 },
				{ amount: charityAmount2, isDefault: defaultCharityAmountIndex === 2 },
				{ amount: charityAmount3, isDefault: defaultCharityAmountIndex === 3 },
			],
		});
		additionalValidationErrors.length
			? setMainFormValidationFail(true)
			: changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleFormValidationFail = () => {
		setMainFormValidationFail(true);
	};

	const revalidateForm = form.validateFields;

	return (
		<div className={style.container}>
			<Form
				form={form}
				name="basic"
				onFinish={submit}
				onKeyPress={preventDefaultForEnterKey}
				onFinishFailed={handleFormValidationFail}
				layout="vertical">
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<NameField changeName={changeName} />
						<ShortNameField changeShortName={changeShortName} />
					</div>
					<div className={style.row}>
						<CustomerSelect setIDCustomer={setIDCustomer} setFetchedCustomers={setFetchedCustomers} />
						<ClientTypeSelect setClientType={setClientType} />
					</div>
					<div className={style.row}>
						<CountrySelect setIDCountry={setIDCountry} setFetchedCountries={setFetchedCountries} />
						<CitySelect
							IDSelectedCountry={IDSelectedCountry}
							setIDCity={setIDCity}
							setFetchedCities={setFetchedCities}
						/>
					</div>
					<div className={style.row}>
						<AddressField changeAddress={changeAddress} />
						<CurrencySelect
							setCurrencySymbol={setCurrencySymbol}
							setFetchedCurrencies={setFetchedCurrencies}
						/>
					</div>
					<div className={style.row}>
						<MasterPhoneField changeMasterPhoneNumber={changeMasterPhoneNumber} />
						<EmailField changeEmail={changeEmail} />
					</div>
					<div className={style.row}>
						<LoyaltyField changeLoyalty={changeLoyalty} />
						<VatIdField changeVatId={changeVatId} />
					</div>
					{featureFlags.HAS_KM_VAT_ID && (
						<div className={rowWithFlex1Classes}>
							<FormInput
								testId="KmVatIdField"
								name="kmVatId"
								label="kmVatIdLabel"
								onChange={changeKmVatId}
							/>
							<div />
						</div>
					)}
				</div>
				{featureFlags.SHOW_PAYMENT_ID_ON_RESTAURANT_FEATURE && (
					<div className={style.fieldsWrapper} data-test="fieldsWrapper">
						<Text
							translationNameSpace="form"
							translationKey="paymentTypeIdHeader"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<div className={rowWithFlex1Classes}>
							<PaymentTypeIdField changePaymentTypeId={changePaymentTypeId} />
							<div />
						</div>
						{featureFlags.SHOW_EXTRA_PAYMENT_TYPES_ON_RESTAURANT_FEATURE && (
							<div>
								<Text
									translationNameSpace="form"
									translationKey="extraPaymentTypeIdHeader"
									theme="secondary"
									size="m"
									weight="bold"
									display="inline"
								/>
								<ExtraPaymentTypeIds
									extraPaymentTypes={extraPaymentTypes}
									addExtraPaymentType={addExtraPaymentType}
									changeExtraPaymentTypes={changeExtraPaymentType}
									deleteExtraPaymentType={deleteExtraPaymentType}
								/>
							</div>
						)}
					</div>
				)}
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="restaurantCodeHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={rowWithFlex1Classes}>
						<CodeField changeCode={changeCode} />
						<div />
					</div>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="additionalApplicationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<AdditionalApplicationsMultipleSelect setAdditionalApplications={setAdditionalApplications} />
					<VivaWallet
						changeVivaWalletIsv={changeVivaWalletIsv}
						additionalApplications={additionalApplications}
						isFranchiseFeeSupported={vivaWalletIsv.franchiseFeeSupported}
					/>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="supplierHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<Supplier
						changeSupplier={changeSupplier}
						toggleIsOpenPriceServiceCharge={toggleIsOpenPriceServiceCharge}
						changeOpenPricePercent={changeOpenPricePercent}
						revalidateForm={revalidateForm}
						isOpenPriceServiceCharge={isOpenPriceServiceCharge}
						supplier={supplier}
					/>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="priceTypeHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={rowWithAlignItemsCenterClasses}>
						<PriceTypeField
							changePriceType={changePriceType}
							isUsedCustomerPriceType={isUsedCustomerPriceType}
						/>
						<IsUsedCustomerPriceTypeCheckbox
							toggleIsUsedCustomerPriceType={toggleIsUsedCustomerPriceType}
							isUsedCustomerPriceType={isUsedCustomerPriceType}
						/>
					</div>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="taxHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<IsApplicableForVat
						toggleApplicableForVat={toggleApplicableForVat}
						isApplicableForVat={isApplicableForVat}
					/>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="tipsHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<IsUseCustomerTipsCheckBox
						toggleIsUsedCustomerTips={toggleIsUsedCustomerTips}
						isUsedCustomerTips={isUsedCustomerTips}
					/>
					<TipsBlock
						setTips0={setTips0}
						setTips1={setTips1}
						setTips2={setTips2}
						setTips3={setTips3}
						setDefaultTips={setDefaultTips}
						defaultTips={defaultTips}
						isDisabled={isUsedCustomerTips}
					/>
					<Text
						translationNameSpace="form"
						translationKey="tipsCommissionHeading"
						theme="secondary"
						size="s"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<TipsCommissionPercentField
							setTipsCommissionPercent={setTipsCommissionPercent}
							revalidateForm={revalidateForm}
						/>
						{tipsCommissionPercent !== null && (
							<TipsCommissionMaxValueField setTipsCommissionMaxValue={setTipsCommissionMaxValue} />
						)}
					</div>
					<Text
						translationNameSpace="form"
						translationKey="kmTariffHeading"
						theme="secondary"
						size="s"
						weight="bold"
						display="inline"
					/>
					<UseKmTariffCheckBox toggleUseKmTariff={toggleUseKmTariff} useKmTariff={useKmTariff} />
				</div>
				{featureFlags.HAS_CHARITY && (
					<div className={style.fieldsWrapper} data-test="fieldsWrapper">
						<Text
							translationNameSpace="form"
							translationKey="charityHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<Charity
							toggleIsCharityEnabled={toggleIsCharityEnabled}
							changeCharityName={changeCharityName}
							setCharityLogoFile={setCharityLogoFile}
							setCharityAmount0={setCharityAmount0}
							setCharityAmount1={setCharityAmount1}
							setCharityAmount2={setCharityAmount2}
							setCharityAmount3={setCharityAmount3}
							setDefaultCharityAmountIndex={setDefaultCharityAmountIndex}
							changeTypeOfModalWindow={changeTypeOfModalWindow}
							revalidateForm={revalidateForm}
							isCharityEnabled={isCharityEnabled}
							charityLogoFileId={charityLogoFileId}
							charityLogoPath={charityLogoPath}
							charityAmount0={charityAmount0}
							charityAmount1={charityAmount1}
							charityAmount2={charityAmount2}
							charityAmount3={charityAmount3}
							defaultCharityAmountIndex={defaultCharityAmountIndex}
						/>
					</div>
				)}
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="mccHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<Mcc
						changeBaseMcc={changeBaseMcc}
						changeMccCardMcc={changeMccCardMcc}
						changeMainMccCardMcc={changeMainMccCardMcc}
						changeMainMccCardBrand={changeMainMccCardBrand}
						changeMccCardBrand={changeMccCardBrand}
						addMccCard={addMccCard}
						deleteMccCard={deleteMccCard}
						selectedMainMccCardBrand={mainMccCardBrand}
						mccCards={mccCards}
						reservedMccCardBrands={reservedMccCardBrands}
						useCustomerMcc={useCustomerMcc}
						toggleUseCustomerMcc={toggleUseCustomerMcc}
					/>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="loyaltyProgramHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<ShowLoyaltyProgramButtonsCheckBox
						toggleShowLoyaltyProgramButtons={toggleShowLoyaltyProgramButtons}
						isShowLoyaltyProgramButtons={isShowLoyaltyProgramButtons}
						isShowCustomerLoyaltyProgramButtons={isShowCustomerLoyaltyProgramButtons}
					/>
					<Text
						translationNameSpace="form"
						translationKey="loyaltyAppDownloadUrlHeading"
						theme="secondary"
						size="s"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<DownloadAppAndroidUrlField
							changeDownloadAppAndroidUrl={changeDownloadAppAndroidUrl}
							isShowCustomerLoyaltyProgramButtons={isShowCustomerLoyaltyProgramButtons}
						/>
						<DownloadAppIosUrlField
							changeDownloadAppIosUrl={changeDownloadAppIosUrl}
							isShowCustomerLoyaltyProgramButtons={isShowCustomerLoyaltyProgramButtons}
						/>
					</div>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="languagesHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<DefaultLanguageSelect
							IDSelectedCustomer={IDSelectedCustomer}
							setIDDefaultLanguage={setIDDefaultLanguage}
							setFetchedLanguages={setFetchedLanguages}
						/>
						<LanguagesMultipleSelect
							IDSelectedCustomer={IDSelectedCustomer}
							IDDefaultLanguage={IDDefaultLanguage}
							IDsLanguages={IDsLanguages}
							setIDsLanguages={setIDsLanguages}
						/>
					</div>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="QRChatBotCodeHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<RestrictionQrValueField changeRestrictionQrValue={changeRestrictionQrValue} />
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="posPhotosHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<UsePosPhotosCheckBox usePosPhotos={usePosPhotos} toggleUsePosPhotos={toggleUsePosPhotos} />
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="updateLauncherHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<UpdateOfTheLauncherCheckBox
						toggleUpdateOfTheLauncher={toggleUpdateOfTheLauncher}
						updateOfTheLauncher={updateOfTheLauncher}
					/>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						className={style.menuContentVersionHeading}
						translationNameSpace="form"
						translationKey="menuContentVersionHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={versionHeadingClasses}>
						<Text
							translationNameSpace="form"
							translationKey="menuVersionHeading"
							theme="secondary"
							size="m"
							weight="bold"
							display="inline"
						/>
						<Text
							translationNameSpace="form"
							translationKey="contentVersionHeading"
							theme="secondary"
							size="m"
							weight="bold"
							display="inline"
						/>
					</div>
					<div className={rowWithFlex1Classes}>
						<UseCustomerMenuVersionCheckBox
							toggleUseMenuVersion={toggleUseMenuVersion}
							useMenuVersion={useMenuVersion}
						/>
						<UseCustomerContentVersionCheckBox
							toggleUseContentVersion={toggleUseContentVersion}
							useContentVersion={useContentVersion}
						/>
					</div>
					<div className={style.row}>
						<MenuVersionField
							changeMenuVersion={changeRestaurantMenuVersion}
							useMenuVersion={useMenuVersion}
						/>
						<ContentVersionField
							changeContentVersion={changeRestaurantContentVersion}
							useContentVersion={useContentVersion}
						/>
					</div>
					<div className={rowWithFlex1Classes}>
						<UseRestaurantMenuVersionCheckBox
							toggleUseMenuVersion={toggleUseMenuVersion}
							useMenuVersion={useMenuVersion}
						/>
						<UseRestaurantContentVersionCheckBox
							toggleUseContentVersion={toggleUseContentVersion}
							useContentVersion={useContentVersion}
						/>
					</div>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="terminalHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<CardAcceptorIdField changeCardAcceptorId={changeCardAcceptorId} />
						<CardAcceptorNameField changeCardAcceptorName={changeCardAcceptorName} />
					</div>
					<div className={style.row}>
						<TerminalIdField changeTerminalId={changeTerminalId} />
						<VatField changeVat={changeVat} />
					</div>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="timeBlockHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<TimeBlockChildAccessField changeTimeBlockChildAccess={changeTimeBlockChildAccess} />
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="enableStopListHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<EnableStopListJobCheckBox
						enableStopListJob={enableStopListJob}
						toggleStopListJob={toggleStopListJob}
					/>
					<UseCustomerStopListSyncIntervalCheckBox
						toggleUseCustomerStopListSyncInterval={toggleUseCustomerStopListSyncInterval}
						useCustomerStopListSyncInterval={useCustomerStopListSyncInterval}
					/>
					<StopListSyncIntervalField
						changeStopListSyncIntervalMinutes={changeStopListSyncIntervalMinutes}
						revalidateForm={revalidateForm}
						useCustomerStopListSyncInterval={useCustomerStopListSyncInterval}
					/>
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="posHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<PosSystemSelect setIDPosSystem={setIDPosSystem} />
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="launcherSettingsHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<LauncherSettingsUploader
						fileIdForLauncherSettings={fileIdForLauncherSettings}
						launcherSettingFilePath={launcherSettingFilePath}
						setFileIdForLauncherSettings={setFileIdForLauncherSettings}
					/>
				</div>
				{superUserAccess && isActiveBpa && (
					<div className={style.fieldsWrapper} data-test="fieldsWrapper">
						<Text
							translationNameSpace="form"
							translationKey="bpaHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
							data-test="bpaHeading"
						/>
						<Bpa setBpa={setBpaSetId} IDSelectedCustomer={IDSelectedCustomer} bpaSetId={bpaSetId} />
					</div>
				)}
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="clientTLSCertificateHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<UseTLSCertificate
						toggleUseTLSCertificate={toggleUseTLSCertificate}
						useTlsCertificate={useTlsCertificate}
					/>
					{useTlsCertificate && (
						<div className={style.row}>
							<TLSCertificateLevelSelect setTlsCertificateLevel={setTlsCertificateLevel} />
							{tlsCertificateLevel === 'Restaurant' && (
								<TlsCertificateNameField changeTlsCertificateName={changeTlsCertificateName} />
							)}
						</div>
					)}
					{tlsCertificateLevel === 'Restaurant' && (
						<TlsFileSection
							setTlsCertificateFile={setTlsCertificateFile}
							changeTypeOfModalWindow={changeTypeOfModalWindow}
							tlsCertificateFileId={tlsCertificateFileId}
							tlsCertificateFilePath={tlsCertificateFilePath}
						/>
					)}
					{tlsCertificateLevel === 'Device' && (
						<Text
							translationNameSpace="form"
							translationKey="toUseThisOptionForDevicesIndividuallyOpenDeviceLevelAndSetPreferences"
							size="xs"
							theme="neutralLight"
						/>
					)}
				</div>
				<div className={style.fieldsWrapper} data-test="fieldsWrapper">
					<Text
						translationNameSpace="form"
						translationKey="deviceUnavailabilityAlertsHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<SendDeviceUnavailabilityAlerts
						toggleSendDeviceUnavailabilityAlerts={toggleSendDeviceUnavailabilityAlerts}
						sendDeviceUnavailabilityAlerts={sendDeviceUnavailabilityAlerts}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
});
